import Hotjar from "@hotjar/browser";
import { useEffect, useState } from "react";

export const HotjarConfig = () => {
  const [hotjarInitialized, setHotjarInitialized] = useState(false);

  useEffect(() => {
    if (!hotjarInitialized) {
      setHotjarInitialized(true);
      Hotjar.init(parseInt(`${process.env.NEXT_PUBLIC_HOTJAR_SITE_ID}`), 6);
    }
  }, [hotjarInitialized]);

  return null;
};
